import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import loadable from '@loadable/component';

const Participated = loadable(() => import('@pages/home/Participated'));
const Built = loadable(() => import('@pages/home/Built'));
const Builder = loadable(() => import('@pages/builder/Builder'));
const Share = loadable(() => import('@pages/share/Share'));
const Result = loadable(() => import('@pages/result/Result'));
const ParticipateDetail = loadable(() => import('@pages/builder/ParticipateDetail'));
const Guide = loadable(() => import('@components/page/GuidePage'));
const Error = loadable(() => import('@components/page/Error'));
const Error404 = loadable(() => import('@components/page/Error404'));
// const IEGuide = loadable(() => import('@components/page/IEGuide'));

function App() {
  return (
    <>
      <Switch>
        <Redirect exact path="/" to="/participated" />
        <Route path="/built" component={Built} />
        <Route path="/participated" component={Participated} />
        <Route path="/builder" component={Builder} />
        <Route path="/share" component={Share} />
        <Route path="/result" component={Result} />
        <Route path="/TO" component={ParticipateDetail} />
        <Route path="/guide" component={Guide} />
        <Route path="/error" component={Error} />
        {/*<Route path="/ieGuide" component={IEGuide} />*/}
        <Route component={Error404} />
      </Switch>
    </>
  );
}

export default App;
